<template>
  <el-row class="topnav_framework">
    <el-col>
      <el-col :span="14" class="topnav_title">
        <p>{{ '紫东线上生活超市管理平台' + testVerName}}</p>
      </el-col>
      <!-- <el-col :span="10" class="topnav_profile"> -->
        <el-col :span="7">
          <p class="topnav_profile">
            {{loginData.mobile}}，欢迎您！
          </p>
        </el-col>
        <el-col :span="3">
          <el-button class="topnav_log" type="text" @click="adminLogout()">退出登录</el-button>
          <el-button v-if="!this.$store.state.visitorMode" type="text" @click="dialogFormVisible = true">修改密码</el-button>
        </el-col>
      <!-- </el-col> -->
    </el-col>
    <!-- <el-dialog title="登录" :visible.sync="loginVisible" :append-to-body="true" width="500px">
      <el-form :model="loginData" :rules="formRules" size="medium" label-width="80px" style="margin:0 10px">
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="loginData.mobile" placeholder="请输入手机号" prefix-icon='el-icon-phone' :style="{width: '100%'}"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="loginData.password" placeholder="请输入密码" prefix-icon='el-icon-user-solid' :style="{width: '100%'}" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelLogin()">取消</el-button>
        <el-button type="primary" @click="confirmLogin()">确定</el-button>
      </div>
    </el-dialog> -->
    <el-dialog title="修改密码"
               :visible.sync="dialogFormVisible"
               :before-close="handleDialogClose"
               @close="initDialog"
               :append-to-body="true"
               center>
      <el-form ref="changePasswordForm"
               :model="changePasswordForm"
               :rules="rules"
               label-width="80px">
        <el-row type="flex" justify="center">
          <el-col :span="12">
            <el-form-item label="新密码" prop="newPassword">
              <el-input v-model="changePasswordForm.newPassword" placeholder="请输入新密码" type="password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="12">
            <el-form-item label="确认密码" prop="repeatNewPassword">
              <el-input v-model="changePasswordForm.repeatNewPassword" placeholder="请输入新密码" type="password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeNewPassword">提交修改</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
  import STORE from '@/store'
  import GLOBAL from '@/utils/global.js'

  export default {
    inject: ["hideTopNav"],
    name: "TopNav",
    components: {},
    data() {
      return {
        GLOBAL,
        // isLogined: false,
        loginData: {
          mobile: '',
          password: '',
        },
        // loginVisible: false,
        formRules: {
          mobile: [{
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          }],
          password: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }],
        },
        dialogFormVisible: false,
        changePasswordForm:{
          newPassword: '',
          repeatNewPassword: '',
        },
        rules:{
          newPassword:[{
            required: true, message: '请输入新密码', trigger: 'blur'
          }],
          repeatNewPassword: [{
            required: true, message: '请确认新密码', trigger: 'blur'
      }]
        },
        testVerName: '',
      };
    },
    created() {
      if (sessionStorage.getItem("token")) {
        // this.isLogined = true;
        this.loginData.mobile = JSON.parse(sessionStorage.getItem('profile')).mobile;
      }
      this.testVerName = GLOBAL.testVerName;
    },
    methods: {
      // adminLogin() {
      //   this.loginVisible = true;
      // },
      adminLogout() {
        // this.isLogined = false;
        return new Promise((resolve, reject) => {
          STORE
            .dispatch("User/logout", {})
            .then((res) => {
              this.$message({
                message: '退出登录成功',
                type: 'success'
              });
              this.hideTopNav();
              this.$router.replace('/');
              resolve(res);
            })
            .catch((error) => {
              reject(error);
            });
        });

      },
      // cancelLogin() {
      //   this.loginVisible = false;
      // },
      // confirmLogin() {
      //   return new Promise((resolve, reject) => {
      //     STORE
      //       .dispatch("User/login", this.loginData)
      //       .then((res) => {
      //         this.loginVisible = false;
      //         this.isLogined = true;
      //         this.$message({
      //           message: '登录成功',
      //           type: 'success'
      //         });
      //         //页面刷新
      //         location.reload();
      //         resolve(res);
      //       })
      //       .catch((error) => {
      //         this.$message({
      //           message: '登录失败',
      //           type: 'error'
      //         });
      //         reject(error);
      //       });
      //   });
      // }
      handleDialogClose(done) {
        this.$confirm("操作未保存，是否退出？")
            .then( () => {
              // this.$refs['form'].resetFields();
              done();
            })
            .catch( () => {
              // this.$refs['form'].resetFields();
            });
      },
      initDialog(){
       this.$refs['changePasswordForm'].resetFields();
      },
      changeNewPassword(){
        if(this.changePasswordForm.newPassword !== ''
            && this.changePasswordForm.repeatNewPassword !== ''
            &&this.changePasswordForm.newPassword === this.changePasswordForm.repeatNewPassword){
          this.$store.dispatch("User/changeNewPassword", {
            newPassword: this.changePasswordForm.newPassword})
              .then((res) => {
                console.log(res)
              })
              .catch((res) => {
                console.log(res);
                // if (this.GLOBAL.debugMode) {
                //   console.log("addCategories");
                // }
              })
          this.newPassword = '';
          this.dialogFormVisible = false;
        }else if(this.changePasswordForm.newPassword === '' || this.changePasswordForm.repeatNewPassword === '' ){
          this.$confirm('密码输入为空', '提示', {
            confirmButtonText: '返回修改',
            cancelButtonText: '退出',
            type: 'warning'
          }).then(() => {})
              .catch(() => {
                this.dialogFormVisible = false;
              })
        }else if(this.changePasswordForm.newPassword !== this.changePasswordForm.repeatNewPassword){
          this.$confirm('两次输入密码不一致', '提示', {
            confirmButtonText: '返回修改',
            cancelButtonText: '退出',
            type: 'warning'
          }).then(() => {})
              .catch(() => {
                this.dialogFormVisible = false;
              })
        }
      }
    },
  };
</script>

<style>
  * {
    font-family: PingFangSC-Medium, PingFang SC;
  }

  .topnav_framework {
    border-bottom: 1px solid #eee;
  }

  .topnav_title {
    text-align: left;
  }

  .topnav_title p {
    font-size: 20px;
    line-height: 50px;
    margin: 0 0 0 20px;
  }

  .topnav_profile {
    text-align: end;
    font-size: 14px;
    line-height: 50px;
  }

  .el-button.el-button--text.el-popover__reference,
  .el-button.topnav_log.el-button--text {
    line-height: 50px;
    padding: 0 0 0 0;
  }

  .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
